// extracted by mini-css-extract-plugin
module.exports = {"root":"DropdownBase_root__3pr0c","optionsHolder":"DropdownBase_optionsHolder__1pxWH","options":"DropdownBase_options__2ce5J","has-items":"DropdownBase_has-items__2Vdd5"};